<template>
  <div class="row">
      <div class="row page-title">
          <div class="col-md-2">
              <back-button returnUrl="/parameters"></back-button>
          </div>
          <div class="col-md-11">
              <h4><u>Κανόνες Ασφαλείας</u></h4>
          </div>
      </div>

      <div class="col-lg-8 col-xl-5 col-md-offset-2">
          <form class="forms-style" @submit.prevent="onSubmit">
              <div v-if="securityRoules != null">
                  <div class="form-group">
                      <label for="PasswordMinimumLength"
                          class="col-sm-5 control-label">Ελάχιστο μήκος Password</label>
                      <input type="text" class="form-field" id="PasswordMinimumLength"
                              v-model="securityRoules.PasswordMinimumLength" required>
                  </div>
                  <div class="form-group">
                      <label for="PasswordMaximumLength"
                          class="col-sm-5 control-label">Μέγιστο μήκος Password</label>
                      <input type="text" class="form-field" id="PasswordMaximumLength"
                              v-model="securityRoules.PasswordMaximumLength" required>
                  </div>

                  <!-- <div class="form-group">
                      <label for="NumberOfLoginTries" class="col-sm-5 control-label">Number Of Login Tries</label>
                      <div class="col-sm-7">
                          <input type="text" class="form-field" id="NumberOfLoginTries"
                              v-model="securityRoules.NumberOfLoginTries" required>
                      </div>
                  </div>
                  <div class="form-group">
                      <label for="MinutesOfLockTime" class="col-sm-5 control-label">Minutes Of LockTime</label>
                      <div class="col-sm-7">
                          <input type="text" class="form-field" id="MinutesOfLockTime"
                              v-model="securityRoules.MinutesOfLockTime" required>
                      </div>
                  </div> -->

                  <div class="form-group">
                      <label for="MinimumNumbers" class="col-sm-5 control-label">Ελάχιστο πλήθος αριθμών</label>
                      <input type="text" class="form-field" id="MinimumNumbers"
                              v-model="securityRoules.MinimumNumbers" required>
                  </div>
                  <div class="form-group">
                      <label for="MinimumLetters" class="col-sm-5 control-label">Ελάχιστο πλήθος γραμμάτων</label>
                      <input type="text" class="form-field" id="MinimumLetters"
                              v-model="securityRoules.MinimumLetters" required>
                  </div>
                  <div class="form-group">
                      <label for="MinimumSpecialCharacters"
                          class="col-sm-5 control-label">Ελάχιστο πλήθος ειδικών χαρακτήρων</label>
                      <input type="text" class="form-field" id="MinimumSpecialCharacters"
                              v-model="securityRoules.MinimumSpecialCharacters" required>
                  </div>
                  <button type="submit" @click="save">Αποθήκευση</button>
              </div>
          </form>
      </div>
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";
import notify from "devextreme/ui/notify";
import BackButton from "../../components/shared/backButton";

export default {
  components: {
    BackButton,
  },
  data() {
    return {
      loadIndicatorVisible: false,
      securityRoules: null,
    };
  },
  methods: {
    async save() {
      const res = await mainService.post(
        "/SecurityRule/UpdateSecurityRules",
        this.securityRoules
      );
      if (res.data.Message == null) {
        notify("H αποθήκευση έγινε επιτυχώς", "success", 1000);
      } else {
        notify(`${res.data.Message}`, "warning", 3000);
      }
    },
  },
  computed: {},
  watch: {},
  async mounted() {
    this.loadIndicatorVisible = true;
    const res = await mainService.get(`/SecurityRule/GetSecurityRules`);
    this.securityRoules = res.data;
    this.loadIndicatorVisible = false;
  }
};
</script>
<style lang="scss" scoped>
.forms-style {
  
  label{
    width: 280px;
  }
}
</style>